// Einheitliches Chain-Logo — offizielle Logos aus den TrustWallet-Assets (jsdelivr,
// CSP-erlaubt). Fällt bei Ladefehler auf einen markenfarbenen Kreis mit Kürzel zurück.
// Geteilt von WalletRegistry (Wizard) und ChainWalletConnect (Import).

import { useState } from 'react';
import { F } from '../styles/theme';

// Coin → TrustWallet-Blockchain-Ordner.
const TW_CHAIN = {
  BTC: 'bitcoin', LTC: 'litecoin', DOGE: 'doge', BCH: 'bitcoincash', XLM: 'stellar',
  XRP: 'ripple', ADA: 'cardano', SOL: 'solana', ETH: 'ethereum', BASE: 'base',
  POLYGON: 'polygon', ARB: 'arbitrum', OP: 'optimism', BNB: 'smartchain',
};

export default function ChainLogo({ coin, size = 40, color = '#888888' }) {
  const [broken, setBroken] = useState(false);
  const folder = TW_CHAIN[coin];
  const url = folder ? `https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/${folder}/info/logo.png` : null;

  if (url && !broken) {
    // Direkt das Logo (TrustWallet-Chain-Logos bringen ihren eigenen runden Hintergrund
    // mit) — KEIN weißer Kreis darunter, sauber zentriert.
    return (
      <img
        src={url} alt={coin}
        width={size} height={size}
        onError={() => setBroken(true)}
        style={{ display: 'block', borderRadius: '50%', flexShrink: 0, objectFit: 'contain' }}
      />
    );
  }
  return (
    <span style={{
      width: size, height: size, borderRadius: '50%', background: color, color: '#FFFFFF',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      fontWeight: 800, fontSize: Math.round(size * 0.3), fontFamily: F.family,
    }}>
      {String(coin || '').slice(0, 3)}
    </span>
  );
}
